export const popularComics = [
  {
    id: 1,
    title: '我独自升级',
    author: 'Chugong / Dubu',
    category: '热血',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20cover%20art%20style%2C%20solo%20leveling%20theme%2C%20dark%20fantasy%20warrior%20with%20glowing%20blue%20eyes%2C%20dramatic%20pose%2C%20dynamic%20action%2C%20illustration%20with%20clean%20lines%20and%20vibrant%20color%20contrast%2C%20professional%20manhwa%20art%2C%20simple%20dark%20background%20with%20subtle%20gradient&width=400&height=560&seq=comic-01&orientation=portrait',
    rating: 9.7,
    description: '讲述了全球各地出现连接异次元的"门"，猎人需要猎杀门内的魔兽首领的故事。主角成振宇从最弱猎人逐步成长为最强存在。',
    status: '连载中',
    latestChapter: '第 187 话',
    updateTime: '2 小时前',
    views: '2980万',
    tag: 'HOT',
    tagColor: 'accent',
  },
  {
    id: 2,
    title: '神之塔',
    author: 'SIU',
    category: '奇幻',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20cover%20art%20style%2C%20tower%20of%20god%20theme%2C%20mysterious%20boy%20climbing%20a%20giant%20tower%2C%20fantasy%20world%20elements%2C%20magical%20atmosphere%2C%20illustration%20with%20rich%20colors%20and%20detailed%20background%2C%20professional%20manhwa%20art%2C%20simple%20dark%20background%20with%20subtle%20gradient&width=400&height=560&seq=comic-02&orientation=portrait',
    rating: 9.5,
    description: '少年夜为了追寻唯一的朋友蕾哈尔，闯入神秘的神之塔，每一次登塔都需要通过层层考验，是一个充满奇幻与冒险的故事。',
    status: '连载中',
    latestChapter: '第 632 话',
    updateTime: '5 小时前',
    views: '1850万',
    tag: '推荐',
    tagColor: 'primary',
  },
  {
    id: 3,
    title: '女神降临',
    author: 'Yaongyi',
    category: '恋爱',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20cover%20art%20style%2C%20romance%20theme%2C%20beautiful%20girl%20with%20makeup%20transformation%2C%20school%20setting%2C%20love%20triangle%20vibe%2C%20soft%20pastel%20color%20palette%2C%20illustration%20with%20clean%20lines%2C%20professional%20manhwa%20art%2C%20simple%20light%20background%20with%20subtle%20gradient&width=400&height=560&seq=comic-03&orientation=portrait',
    rating: 9.3,
    description: '长相平凡的女高中生通过化妆技巧变成校园女神，与两位男生之间发生的甜蜜又纠结的恋爱故事。',
    status: '已完结',
    latestChapter: '第 223 话（完结）',
    updateTime: '2026-06-20',
    views: '3560万',
    tag: '热门',
    tagColor: 'accent',
  },
];

export const latestUpdates = [
  {
    id: 4,
    title: '剑尊归来',
    author: '有金 / LICO',
    category: '武侠',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20cover%20art%20style%2C%20martial%20arts%20swordsman%20theme%2C%20ancient%20Korean%20warrior%20with%20sword%2C%20dramatic%20wind%20effect%2C%20traditional%20clothing%2C%20illustration%20with%20dynamic%20brushwork%2C%20professional%20manhwa%20art%2C%20simple%20dark%20background%20with%20subtle%20gradient&width=400&height=560&seq=comic-04&orientation=portrait',
    rating: 9.6,
    status: '连载中',
    latestChapter: '第 128 话',
    updateTime: '30 分钟前',
  },
  {
    id: 5,
    title: '全知读者视角',
    author: 'sing N song / Sleepy-C',
    category: '奇幻',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20cover%20art%20style%2C%20apocalyptic%20fantasy%20theme%2C%20protagonist%20in%20modern%20clothing%20facing%20monsters%2C%20dramatic%20scene%2C%20dark%20atmosphere%20with%20glowing%20elements%2C%20professional%20manhwa%20art%2C%20simple%20dark%20background%20with%20subtle%20gradient&width=400&height=560&seq=comic-05&orientation=portrait',
    rating: 9.4,
    status: '连载中',
    latestChapter: '第 215 话',
    updateTime: '1 小时前',
  },
  {
    id: 6,
    title: '重生之都市修仙',
    author: '大行道',
    category: '玄幻',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20cover%20art%20style%2C%20cultivation%20fantasy%20theme%2C%20modern%20city%20with%20supernatural%20elements%2C%20young%20man%20with%20spiritual%20energy%20effects%2C%20illustration%20with%20vibrant%20colors%2C%20professional%20manhwa%20art%2C%20simple%20dark%20background%20with%20subtle%20gradient&width=400&height=560&seq=comic-06&orientation=portrait',
    rating: 9.2,
    status: '连载中',
    latestChapter: '第 342 话',
    updateTime: '3 小时前',
  },
  {
    id: 7,
    title: '漂亮干姐姐',
    author: 'Dalso',
    category: '恋爱',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20cover%20art%20style%2C%20office%20romance%20theme%2C%20handsome%20man%20and%20beautiful%20woman%20in%20modern%20setting%2C%20romantic%20atmosphere%2C%20soft%20warm%20color%20palette%2C%20professional%20manhwa%20art%2C%20simple%20light%20background%20with%20subtle%20gradient&width=400&height=560&seq=comic-07&orientation=portrait',
    rating: 9.1,
    status: '连载中',
    latestChapter: '第 89 话',
    updateTime: '4 小时前',
  },
  {
    id: 8,
    title: '狂暴战神',
    author: 'Redice Studio',
    category: '热血',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20cover%20art%20style%2C%20fierce%20battle%20theme%2C%20muscular%20warrior%20in%20combat%20pose%2C%20explosive%20action%20scene%2C%20dramatic%20lighting%20with%20shadows%2C%20professional%20manhwa%20art%2C%20simple%20dark%20background%20with%20subtle%20gradient&width=400&height=560&seq=comic-08&orientation=portrait',
    rating: 9.0,
    status: '连载中',
    latestChapter: '第 156 话',
    updateTime: '6 小时前',
  },
];

export const categories = [
  { id: 1, name: '热血', slug: 'rexue', icon: 'ri-fire-line', count: 1280, color: 'accent' },
  { id: 2, name: '恋爱', slug: 'lianai', icon: 'ri-heart-line', count: 2150, color: 'primary' },
  { id: 3, name: '奇幻', slug: 'qihuan', icon: 'ri-magic-line', count: 980, color: 'secondary' },
  { id: 4, name: '武侠', slug: 'wuxia', icon: 'ri-sword-line', count: 650, color: 'accent' },
  { id: 5, name: '玄幻', slug: 'xuanhuan', icon: 'ri-moon-line', count: 1120, color: 'primary' },
  { id: 6, name: '悬疑', slug: 'xuanyi', icon: 'ri-search-eye-line', count: 430, color: 'secondary' },
  { id: 7, name: '搞笑', slug: 'gaoxiao', icon: 'ri-emotion-laugh-line', count: 760, color: 'accent' },
  { id: 8, name: '恐怖', slug: 'kongbu', icon: 'ri-ghost-line', count: 320, color: 'primary' },
];

export const faqs = [
  {
    id: 1,
    question: '韩漫网上的漫画真的全部免费吗？',
    answer: '是的，韩漫在线（韩漫网）上的所有韩国漫画都可以免费阅读。我们致力于为漫画爱好者提供免费的韩国漫画大全，无需注册即可畅享全集下拉式阅读体验。部分最新章节可能会在更新后24小时内免费开放。',
  },
  {
    id: 2,
    question: '什么是下拉式阅读？如何使用？',
    answer: '下拉式阅读是韩漫网为优化移动端和桌面端阅读体验而设计的浏览方式。您只需向下滑动页面即可连续阅读漫画内容，无需翻页点击，阅读更流畅自然。进入任意漫画详情页后，系统会自动加载下拉式阅读模式。',
  },
  {
    id: 3,
    question: '如何找到我想看的韩漫？',
    answer: '您可以通过韩漫网顶部的搜索栏直接搜索漫画名称，也可以浏览分类页面按类型筛选。我们还提供人气推荐和最新更新列表，帮助您发现优质韩国漫画。',
  },
  {
    id: 4,
    question: '多久更新一次新的漫画章节？',
    answer: '韩漫在线上的漫画更新频率因作品而异。热门连载作品通常每周更新1-2话，部分作品可能每两周更新一次。您可以关注我们的最新更新列表，第一时间获取更新通知。',
  },
  {
    id: 5,
    question: '支持在手机上阅读吗？',
    answer: '完全支持！韩漫网采用响应式设计，在手机、平板和电脑上都能获得出色的阅读体验。我们的下拉式阅读方式在移动端尤其流畅，随时随地追更您喜欢的韩国漫画。',
  },
  {
    id: 6,
    question: '遇到页面加载慢怎么办？',
    answer: '如果遇到加载慢的情况，可以尝试刷新页面或切换网络环境。韩漫网的服务器经过优化，一般情况下加载速度很快。如仍有问题，欢迎通过页面底部的联系方式向我们反馈。',
  },
];

export const stats = [
  { id: 1, label: '漫画总数', value: '8,500+', icon: 'ri-book-open-line' },
  { id: 2, label: '日均更新', value: '120+', icon: 'ri-refresh-line' },
  { id: 3, label: '注册用户', value: '320万', icon: 'ri-user-line' },
  { id: 4, label: '累计阅读', value: '15亿+', icon: 'ri-eye-line' },
];

export const features = [
  {
    id: 1,
    title: '下拉式阅读',
    description: '创新的下拉式阅读体验，无需翻页，流畅滑动即可畅享漫画世界。优化后的排版让每一格漫画都完美呈现。',
    icon: 'ri-scroll-to-bottom-line',
  },
  {
    id: 2,
    title: '海量韩漫资源',
    description: '收录超过8500部韩国漫画，涵盖热血、恋爱、奇幻、武侠等全部分类，满足各类读者需求。',
    icon: 'ri-stack-line',
  },
  {
    id: 3,
    title: '极速更新',
    description: '与韩国同步更新，热门作品第一时间翻译上线，让你永远快人一步追到最新剧情。',
    icon: 'ri-flashlight-line',
  },
  {
    id: 4,
    title: '智能推荐',
    description: '基于阅读偏好为你精准推荐相似作品，发现更多冷门佳作，拓展你的漫画收藏。',
    icon: 'ri-thumb-up-line',
  },
];